export const CLIENT = {
	CLIENT_SET_SELECTED: "CLIENT_SET_SELECTED",
	CLIENT_CLEAR_SELECTED: "CLIENT_CLEAR_SELECTED",
	CLIENT_NAME_SET_SELECTED: "CLIENT_NAME_SET_SELECTED",
	CLIENT_NAME_CLEAR_SELECTED: "CLIENT_NAME_CLEAR_SELECTED",
	// CLIENT_LIST_REQUEST_LOAD: "CLIENT_LIST_REQUEST_LOAD",
	// CLIENT_LIST_REQUEST_SUCCESS: "CLIENT_LIST_REQUEST_SUCCESS",
	// CLIENT_LIST_REQUEST_FAILED: "CLIENT_LIST_REQUEST_FAILED",
	// CLIENT_NAME_SET_SELECTED: "CLIENT_NAME_SET_SELECTED",
	// CLIENT_NAME_CLEAR_SELECTED: "CLIENT_NAME_CLEAR_SELECTED",

	// CLIENT_LIST_REQUEST_LOAD: "CLIENT_CLIENT_LIST_REQUEST_LOAD",
	// CLIENT_LIST_REQUEST_SUCCESS: "CLIENT_CLIENT_LIST_REQUEST_SUCCESS",
	// CLIENT_LIST_REQUEST_FAILED: "CLIENT_CLIENT_LIST_REQUEST_FAILED",
};
